<template>
    <div class="share container">


        <div class="row u-p1" v-if="loading">
            <div class="col-12">
                <div class="card horizontal">
                    <div class="card-stacked">
                        <div class="card-content">
                             <div class="row center">
                                <div class="col-12">
                                   <div class="u-p2">
                                        <div class="spinner">
                                        <div class="rect1"></div>
                                        <div class="rect2"></div>
                                        <div class="rect3"></div>
                                        <div class="rect4"></div>
                                        <div class="rect5"></div>
                                        </div>
                                        <h1>Please wait while we submit your form</h1>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row u-p1" v-if="complete">
            <div class="col-12">
                <div class="card horizontal">
                    <div class="card-stacked">
                        <div class="card-content">
                             <div class="row center">
                                <div class="col-12">
                                    <div class="u-p2">
                                        <svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52"><circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none"/><path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/></svg>
                                        <h1>Submitted!</h1>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <div class="row form-name">
            <div class="col-12 center">
                <div class="form-logo" v-if="logo">
                    <img :src="logo" :alt="subtitle" />
                </div>
                <h3 class="subtitle t-secondary" v-else :style="primaryColour ? 'color: ' + primaryColour + ';' : ''">{{subtitle}}</h3>
                <h1 class="title teal-text lighten-2">{{title}}</h1>
            </div>
        </div>
        <div class="row u-p1" id="formStart">
            <div class="col-12">
                <div class="card horizontal u-p1">
                    <div class="card-stacked">
                        <div class="card-content">
                            <div class="row">
                                <div class="col-12 center">
                                    <h4>Please complete the below to get started</h4>
                                    <br>
                                </div>
                                <div class="col-12 col-md-6">
                                    <div class="input-group u-mb1">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text"><i class="fas fa-file-signature prefix"></i></div>
                                    </div>
                                    <input class="form-control" placeholder="Enter your firstname" id="firstname" type="text" required>

                                    </div>


                                </div>
                                <div class="col-12 col-md-6">
                                        <div class="input-group u-mb1">
                                        <div class="input-group-prepend">
                                            <div class="input-group-text"><i class="fas fa-file-signature prefix"></i></div>
                                        </div>
                                        <input class="form-control" placeholder="Enter your surname" id="surname" type="text" required>
                                        </div>



                                </div>
                                <div class="col-12" :class="dataCapture ? 'col-md-6' : 'col-md-12'">

                                         <div class="input-group u-mb1">
                                        <div class="input-group-prepend">
                                            <div class="input-group-text"><i class="fas fa-at prefix"></i></div>
                                        </div>
                                        <input class="form-control" placeholder="Enter your email" id="email_address" type="email" required>
                                        </div>

                                </div>
                                <div class="col-12 col-md-6" v-if="dataCapture">

                                         <div class="input-group u-mb1">
                                        <div class="input-group-prepend">
                                            <div class="input-group-text"><i class="fas fa-mobile prefix"></i></div>
                                        </div>
                                        <input class="form-control"  placeholder="Enter your mobile" id="mobile" type="number" required>
                                        </div>

                                </div>
                                <div class="col-12 col-md-6" v-if="dataCapture">

                                         <div class="input-group u-mb1">
                                        <div class="input-group-prepend">
                                            <div class="input-group-text"><i class="fas fa-birthday-cake prefix"></i></div>
                                        </div>
                                        <input class="form-control" placeholder="Enter your date of birth" id="dob" type="date">
                                        </div>

                                </div>
                                <div class="col-12 col-md-6" v-if="dataCapture">

                                        <div class="input-group u-mb1">
                                                <div class="input-group-prepend">
                                                <label class="input-group-text" for="gender"> <i class="fas fa-user prefix"></i></label>
                                            </div>
                                            <select class="custom-select" id="gender">
                                                <option value="" disabled selected>Choose your gender</option>
                                                <option value="Male">Male</option>
                                                <option value="Female">Female</option>
                                                <option value="Rather not say">Rather not say</option>
                                            </select>
                                        </div>

                                </div>
                                <div class="col-12" v-if="dataCapture">
                                        <div class="input-group u-mb1">
                                        <div class="input-group-prepend">
                                            <div class="input-group-text"><i class="fas fa-building prefix"></i></div>
                                        </div>
                                        <input class="form-control" placeholder="Current occupation" id="occupation"  type="text">
                                        </div>
                                </div>

                            </div>
                            <div class="row u-mt1">
                                <div class="col-12">
                                    <button v-if="canStart" @click="startForm()" class="btn btn-secondary float-right text-light u-full-width" :style="btnStyle">
                                        <i class="fas fa-paper-plane"></i> Start Form
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <form id="builder" name="builder">
	         <div class="form-builder">
	         	<!-- Jquery -->
	         </div>
	         <div class="row paginate-holder">
                <div class="col-12">
                    <div class="row u-p1">
                        <div class="col-6 col-md-2">
                            <button class="btn btn-primary text-light u-full-width previous" type="button" :style="btnStyle">
                                <i class="fas fa-arrow-circle-left"></i> Previous
                            </button>
                        </div>

                        <div class="col-6 offset-md-8 col-md-2">
                            <button class="btn btn-primary text-light u-full-width next" type="button" :style="btnStyle">
                                Next <i class="fas fa-arrow-circle-right"></i>
                            </button>
                        </div>
                    </div>
                </div>
			</div>
             <div class="row submit-holder u-p1">
                <div class="col-12">
                    <button class="btn btn-primary text-light u-full-width submit-form" type="button" :style="btnStyle">
                        <i class="fas fa-paper-plane"></i> Submit
                    </button>
                </div>
            </div>
	    </form>

    </div>
</template>

<script>


import {alerts} from '@/mixins/alerts.js';

export default {
    name: 'share',
    data : function () {
        return {
            profile:{},
            formLoaded : false,
            loading:false,
            complete:false,
            email:'',
            canStart:true,
            form : {
                data_capture : false
            }
        };
    },
    mounted : function () {

        this.$root.loading = true;
        let id = this.$route.params.id;
        if (!id) {
            // get the form ID using the slugs
            let bslug = this.$route.params.bslug,
                fslug = this.$route.params.fslug;
                // this.axios.defaults.headers.common['Authorization'] = this.$root.user_id;
                this.axios.get(this.$root.env_url+'/api/v1/form/forms/_get/'+ bslug + '/' + fslug)
                .then(response => {
                    this.form = response.data.data;
                    this.formStuff(response.data.id);
                })
                .catch(error => {
                    this.errorMsg('Error - We could not find that form');
                    console.error('error loading form', error);
                    this.$root.loading = false;
                })
        } else {
            this.formStuff(id);
        }


    },
    computed : {
        business () {
            if (this.form && this.form.business) {
                return this.form.business;
            }
            return null
        },
        title () {
            if (this.form) {
                return this.form.title;
            }
            return '';
        },
        subtitle () {
            if (this.business) {
                return this.business.name;
            }
            return '';
        },
        primaryColour () {
            if (this.business) {
                return this.business.primary_colour;
            }
            return null;
        },
        secondaryColour () {
            if (this.business) {
                return this.business.secondary_colour;
            }
            return null;
        },
        logo () {
            if (this.business) {
                return this.business.logo_url;
            }
            return null;
        },
        dataCapture () {
            if (this.form) {
                return this.form.data_capture;
            }
            return true;
        },
        btnStyle () {
            let style = '';
            if (this.primaryColour) {
                style += 'background-color: ' + this.primaryColour + ';';
                style += 'border: ' + this.primaryColour + ' 1px solid;';
            }
            if (this.secondaryColour) {
                style += 'color: ' + this.secondaryColour + ' !important;';
            }
            return style;
        }
    },
    components: {},
    methods:{
        formStuff (id) {
            let self = this;
            let online=true;

            $('#builder').hide();
            // if (!this.form.data_capture) {
            //     self.startForm();
            // }

            this.$root.loading = false;
            //grab the form layout based on the id

            initForm(id);
            //
            function initForm(id)
            {
                let params={};
                // self.axios.defaults.headers.common['Authorization'] = self.$root.user_id;
                self.axios.get(self.$root.env_url+'/api/v1/form/forms/'+id, params)
                .then(response => {
                    self.form = response.data.data;
                    buildForm(response)
                })
                .catch(error => {
                    //   alert('Error');
                });

            }
            function buildForm(response)
            {
                let data = JSON.parse(response.data.data.forms);
                let count = 0;
                console.log(data);
                // return;
                $('.form-builder').html('')
                //loop round  the data and buld some pages
                for (var i = 0; i < data.length; i++) {
                    $('.form-builder').append(addPage(data[i], i))
                }
                //activate signable
                let w = $('.card-content').width();
                $('.signable_form').jqSignature({
                    height: 200,
                    width: w
                });

                $('.signable_form').on('jq.signature.changed', function() {
                    let id = $(this).attr('data-name')
                    $('#' + id).val('signed');
                });

                $('.file-upload-btn').on('click', function () {
                    let target = $(this).attr('data-target');
                    console.log('triggered', target);
                    $('input[name=' + target + ']').click();
                });

                $('.file-upload').on('change', function (e) {
                    console.log('file change', $(this), e);
                    let file = e.target.files[0];
                    if (file) {
                        $('#upload-label-' + $(this).attr('name')).html('<i class="fas fa-check t-green"></i> ' + file.name);
                    } else {
                        $('#upload-label-' + $(this).attr('name')).html('<i class="fas fa-times"></i> no document attached');
                    }
                });

                self.formLoaded = true;

                if(data.length > 1)
                {
                    // paginate
                    //loop round and hide all pages
                    $('.pages').hide();
                    $('.section-0').show();
                    $('.submit-holder').hide()
                    $('.previous').hide();
                    //add listeners
                    $('.previous').on('click', function(){
                        count--;
                        console.log(count, data.length)
                        if(count == 0)
                        {
                            $(this).hide();
                            // return !1;
                        }
                        $('.pages').hide();

                        $('.section-'+count).fadeIn();
                        return !1;
                    })

                    $('.next').on('click', function() {
                        let requiredFields = $('input,textarea,select').filter('[required]:visible');
                        let requiredSignables = $('#builder .required:visible');
                        let requiredCheckboxes = $('#builder .form-check-input.required:visible');
                        let empty = validateFields(requiredFields, requiredSignables, requiredCheckboxes);

                        if (empty.length > 0) {
                            console.log('Error on fields', empty); ///
                            self.errorMsg('Please complete all of the required fields');
                            return;
                        }

                        count++;
                        console.log(count, data.length)
                        if(count == data.length-1)
                        {

                            $('.submit-holder').show();
                            $('.paginate-holder').hide();
                            $(this).hide();
                            // return !1;
                        }
                        $('.pages').hide();
                        $('.previous').show();

                        $('.section-'+count).fadeIn();

                        return !1;
                    })
                }else{
                    $('.paginate-holder').hide();
                }

            }
            function addPage(page, n)
            {
                let form = JSON.parse(page)
                let html ='<section class="pages u-p1 section-'+n+'"><div class="row"><div class="col-12 offsdet-m1 m10 offset-l2 l8"><div class="card u-p1  horizontal"><div class="card-stacked"><div class="card-content">';
                //loop round and add the html elements
                for (var i = 0; i < form.length; i++) {
                    html += addInput(html, form[i]);
                }
                html += '</div></div></div></div></div></section>';
                return html;
            }
            function addInput(html,item)
            {
                console.log(item)
                switch (item.type) {
                    case "line": return line(item); break;
                    case "signable": return signable(item); break;
                    case "textarea": return textarea(item); break;
                    case "text": return text(item); break;
                    case "select": return select(item); break;
                    case "radio-group": return radioGroup(item); break;
                    case "paragraph": return paragraph(item); break;
                    case "header": return header(item); break;
                    case "file": return file(item); break;
                    case "date": return date(item); break;
                    case "checkbox-group": return checkboxGroup(item); break;
                }
            }
            function line(item)
            {
                if(online)
                {
                    if(item.placeholder == undefined)
                    {
                        item.placeholder = '';
                    }
                    return '<div class="row u-mb1"><div class="input-field col-12"><hr></div></div>';
                }
            }
            function signable(item)
            {
                if(online)
                {
                    if(item.placeholder == undefined)
                    {
                        item.placeholder = '';
                    }
                    let required = item.required ? 'required' : '';
                    return `<div class="row u-mb1">
                        <div class="input-field col-12">
                            ${label(item)}
                            <div class="signHolder center-align" style="width:100%">
                                <input type="hidden" value="" id="${item.name}" name="${item.name}">
                                <div data-name="${item.name}" class="signable_form ${required}"></div>
                            </div>
                            ${badge(item)}
                        </div>
                    </div>`;
                }

            }
            function textarea(item)
            {
                if(online)
                {
                    let required = item.required ? 'required' : '';
                    if(item.placeholder == undefined)
                    {
                        item.placeholder = '';
                    }
                    return '<div class="row u-mb1"><div class="col-12"><div class="form-group">'+label(item)+'<textarea class="form-control" name="'+item.name+'" id="'+item.name+'" rows="3" ' + required + '></textarea>'+badge(item)+'</div></div></div>';
                }
            }
            function text(item)
            {
                if(online)
                {
                    let required = item.required ? 'required' : '';
                    if(item.placeholder == undefined)
                    {
                        item.placeholder = '';
                    }
                    return '<div class="row u-mb1"><div class="col-12"><div class="form-group">'+label(item)+'<input type="text" class="form-control" name="'+item.name+'" aria-describedby="emailHelp" placeholder="'+item.placeholder+'" ' + required + '>'+badge(item)+'</div></div></div>';
                }
            }
            function select(item)
            {
                let options;
                if (item.placeholder) {
                    options = '<option value="" disabled selected>'+item.placeholder+'</option>';
                }

                item.values.forEach((option) => {
                    console.log('OPTION', option);
                    let label = option.label,
                        value = option.value;

                    if (!label || label == '') {
                        label = option.value;
                    }
                    if (!value || value == '') {
                        value = option.label;
                    }
                    options += `<option value="${value}">${label}</option>`;
                });

                if(online)
                {
                    if(item.placeholder == undefined)
                    {
                        item.placeholder = '';
                    }
                    let required = item.required ? 'required' : '';
                    return `<div class="row u-mb1">
                        <div class="col-12">
                            <div class="form-group">${label(item)}
                                <select class="form-control" name="${item.name}" id="${item.name}" ${required}>
                                    ${options}
                                </select>
                                ${badge(item)}
                            </div>
                        </div>
                    </div>`;
                }
            }
            function radioGroup(item)
            {
                let options='';
                let required = item.required ? 'required' : '';

                item.values.forEach((option, i) => {
                    console.log('OPTION', option);
                    let label = option.label,
                        value = option.value,
                        id    = item.name + i;
                    if (!label || label == '') {
                        label = option.value;
                    }
                    if (!value || value == '') {
                        value = option.label;
                    }
                    options += `<div class="form-check">
                        <label for="${id}">
                            <input class="form-check-input" type="radio" name="${item.name}" id="${id}" value="${value}" ${required}">
                            ${label}
                        </label>
                    </div>`;
                });

                if(online) {
                    if(item.placeholder == undefined) {
                        item.placeholder = '';
                    }
                    return `<div class="row u-mb1">
                        <div class="col-12">
                            ${label(item)}
                            ${options}
                            ${badge(item)}
                        </div>
                    </div>`;
                }
            }
            function paragraph(item)
            {
                if(online)
                {
                    if(item.placeholder == undefined)
                    {
                        item.placeholder = '';
                    }
                    return '<div class="row u-mb1"><div class="input-field col-12"><'+item.subtype+' class="flow-text">'+item.label+'</'+item.subtype+'></div></div>';
                }
            }
            function header(item)
            {
                if(online)
                {
                    if(item.placeholder == undefined)
                    {
                        item.placeholder = '';
                    }
                    return '<div class="row u-mb1"><div class="input-field col-12"><'+item.subtype+'>'+item.label+'</'+item.subtype+'></div></div>';
                }
            }
            function file(item)
            {
                if(online) {
                    if(item.placeholder == undefined) {
                        item.placeholder = '';
                    }
                    let required = item.required ? 'required' : '';
                    return `
                    <div class="row u-mb1">
                        <div class="input-field col-12">
                            ${label(item)}
                            <div style="border:1px dashed #9b9b9b;height:80px;color:#9b9b9b;padding: 1em;text-align: left;width:100%;margin-bottom: 18px; position: relative;">
                                <input type="file" name="${item.name}" ${required} class="file-upload">
                                <button type="button" class="btn btn-secondary file-upload-btn" data-target="${item.name}" style="${self.btnStyle}">Upload Document</button>
                                <div id="upload-label-${item.name}" class="upload-label"> </div>
                            </div>
                            ${badge(item)}
                        </div>
                    </div>`;
                }
            }
            function date(item)
            {
                var date = new Date();

                var day = date.getDate();
                var month = date.getMonth() + 1;
                var year = date.getFullYear();

                if (month < 10) month = "0" + month;
                if (day < 10) day = "0" + day;

                var today = year + "-" + month + "-" + day;    
                if(item.placeholder == undefined)
                {
                    item.placeholder = '';
                }

                let required = item.required ? 'required' : '';
                if(online)
                {
                    if(item.placeholder == undefined)
                    {
                        item.placeholder = '';
                    }
                    return `
                    <div class="row u-mb1">
                        <div class="col-12">
                            <div class="form-group">
                                ${label(item)}
                                <input type="date" value="${today}" class="form-control" name="${item.name}" aria-describedby="emailHelp" placeholder="${item.placeholder}" ${required}>
                                ${badge(item)}
                            </div>
                        </div>
                    </div>`;
                }
            }
            function checkboxGroup(item)
            {
                let options='';
                let required = item.required ? 'required' : '';

                item.values.forEach((option, i) => {
                    console.log('OPTION', option);
                    let label = option.label,
                        value = option.value,
                        id    = item.name + i;
                    if (i > 0) {
                        required = '';
                    }
                    if (!label || label == '') {
                        label = option.value;
                    }
                    if (!value || value == '') {
                        value = option.label;
                    }
                    options += `<div class="form-check">
                        <label for="${id}">
                            <input class="form-check-input ${required}" type="checkbox" name="${item.name}[]" id="${id}" value="${value}">
                            ${label}
                        </label>
                    </div>`;
                });

                if(online)
                {
                    if(item.placeholder == undefined) {
                        item.placeholder = '';
                    }
                    return `<div class="row u-mb1">
                        <div class="col-12">
                            ${label(item)}
                            ${options}
                            ${badge(item)}
                        </div>
                    </div>`;
                }


            }
            function label (item, show=true)
            {
                if(!show)
                {
                    return '';
                }
                let required = "";
                if (item.required) {
                    required = '<span class="t-red"> * </span>'
                }
                return '<label for="'+item.name+'"><strong>'+item.label+'</strong>' + required + '</label>';
            }
            function badge (item, show=true)
            {
                if(!show || item.description == undefined)
                {
                    return '';
                }
                return '<small class="form-text float-right badge badge-secondary text-light">' + item.description + '</small>';
            }

            function validateFields(fields, signables, checkboxes) {
                let empty = [];
                for (var i = 0; i < fields.length; i++) {
                    let field = fields[i];

                    if (field.type == 'radio') {
                        console.log('radio type');
                        let others = $('input:radio[name="' + field.name + '"]');
                        let checked = _.find(others, (radio) => {
                            return radio.checked;
                        });
                        if (!checked) {
                            empty.push(field);
                        }
                    }
                    else if (!field.value || field.value == "") {
                        empty.push(field);
                    }
                }
                // checkboxes work differently - all labelled "required" need to be checked
                // so we can't use required. We add a class to them instead
                for (var i = 0; i < checkboxes.length; i++) {
                    let field = checkboxes[i];
                    console.log('checkbox', field);
                    let others = $('input:checkbox[name="' + field.name + '"]');
                    let checked = _.find(others, (checkbox) => {
                        return checkbox.checked;
                    });
                    if (!checked) {
                        console.log('unchecked checkbox', field);
                        empty.push(document.getElementById(field.id));
                    }
                }
                //signables are not inputs
                for (var i = 0; i < signables.length; i++) {
                    let field = signables[i];
                    let id = field.getAttribute('data-name');
                    let signable = document.getElementById(id);
                    if (signable) {
                        let signed = signable.value;
                        if (signed == '') {
                            empty.push(field);
                        }
                    }

                }
                return empty;
            }

            $('.submit-form').on('click', function()
            {
                let requiredFields = $('#builder :required');
                let requiredSignables = $('#builder .signable_form.required');
                let requiredCheckboxes = $('#builder .form-check-input.required');
                let empty = validateFields(requiredFields, requiredSignables, requiredCheckboxes);

                if (empty.length > 0) {
                    console.log('Error on fields', empty);
                    self.errorMsg('Please complete all of the required fields');
                    return;
                }

                let myForm = document.getElementById('builder');
                let formData = new FormData(myForm);

                for (var i = 0; i < $('.signable_form').length; i++) {
                    let name = $('.signable_form').eq(i).data('name');
                    formData.append(name, $('.signable_form').eq(i).jqSignature('getDataURL'));
                }

                let user = {
                    firstname: $('#firstname').val(),
                    surname: $('#surname').val(),
                    mobile:$('#mobile').val(),
                    dob:$('#dob').val(),
                    gender:$( "#gender option:selected" ).text(),
                    occupation:$('#occupation').val(),
                }
                formData.append('form_id', id);
                formData.append('email', self.email);
                formData.append('user', JSON.stringify(user));

                $('#builder').hide();
                $('.form-name').hide();

                self.loading=true;

                // self.axios.defaults.headers.common['Authorization'] = self.$root.user_id;
                self.axios.post(self.$root.env_url+'/api/v1/form/answers', formData,
                {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
                })
                .then(response => {
                    self.successMsg(response.data.message);
                    self.loading=false;
                    self.complete=true;
                })
                .catch(error => {
                    // this.axiosError(error);
                });


                return !1;
            })
        },
        startForm()
        {
            if($('#firstname').val() == '' || $('#surname').val() == '' || $('#email_address').val() == '')
            {
                this.errorMsg('Please complete all the required fields');
            }else{
                this.email = $('#email_address').val();
                $('#formStart').hide();
                $('#builder').fadeIn();
            }
        }
    },
    watch : {}
}
</script>

<style lang="scss">

@import '../sass/variables.scss';

.spinner {
  margin: 10px auto;
  width: 50px;
  height: 40px;
  text-align: center;
  font-size: 10px;
}

.spinner > div {
  background-color: #333;
  height: 100%;
  width: 6px;
  display: inline-block;
  margin:1px;

  -webkit-animation: sk-stretchdelay 1.2s infinite ease-in-out;
  animation: sk-stretchdelay 1.2s infinite ease-in-out;
}

.spinner .rect2 {
  -webkit-animation-delay: -1.1s;
  animation-delay: -1.1s;
}

.spinner .rect3 {
  -webkit-animation-delay: -1.0s;
  animation-delay: -1.0s;
}

.spinner .rect4 {
  -webkit-animation-delay: -0.9s;
  animation-delay: -0.9s;
}

.spinner .rect5 {
  -webkit-animation-delay: -0.8s;
  animation-delay: -0.8s;
}

@-webkit-keyframes sk-stretchdelay {
  0%, 40%, 100% { -webkit-transform: scaleY(0.4) }
  20% { -webkit-transform: scaleY(1.0) }
}

@keyframes sk-stretchdelay {
  0%, 40%, 100% {
    transform: scaleY(0.4);
    -webkit-transform: scaleY(0.4);
  }  20% {
    transform: scaleY(1.0);
    -webkit-transform: scaleY(1.0);
  }
}

.checkmark__circle {
  stroke-dasharray: 166;
  stroke-dashoffset: 166;
  stroke-width: 2;
  stroke-miterlimit: 10;
  stroke: #7ac142;
  fill: none;
  animation: stroke 0.6s cubic-bezier(0.65, 0, 0.45, 1) forwards;
}

.checkmark {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  display: block;
  stroke-width: 2;
  stroke: #fff;
  stroke-miterlimit: 10;
  margin: auto;
  box-shadow: inset 0px 0px 0px #7ac142;
  animation: fill .4s ease-in-out .4s forwards, scale .3s ease-in-out .9s both;
}

.checkmark__check {
  transform-origin: 50% 50%;
  stroke-dasharray: 48;
  stroke-dashoffset: 48;
  animation: stroke 0.3s cubic-bezier(0.65, 0, 0.45, 1) 0.8s forwards;
}

@keyframes stroke {
  100% {
    stroke-dashoffset: 0;
  }
}
@keyframes scale {
  0%, 100% {
    transform: none;
  }
  50% {
    transform: scale3d(1.1, 1.1, 1);
  }
}
@keyframes fill {
  100% {
    box-shadow: inset 0px 0px 0px 30px #7ac142;
  }
}
.file-upload {
    position : absolute;
    width : 100px;
    height : 40px;
    z-index : 0;
    left : 18px;
}
.file-upload-btn {
    position : absolute;
    z-index : 1;
}
.upload-label {
    position:absolute;
    top: 54px;
    overflow: hidden;
    word-wrap: unset;
    white-space: nowrap;
    width: 94%;
}
.form-name {
    margin-top: 80px;
}
</style>
